var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plk_documentation",domProps:{"innerHTML":_vm._s(_vm.readme)}})}
var staticRenderFns = []

export { render, staticRenderFns }